import { useProductSummaryName } from '../hooks/useProductSummaryName';

const ProductNameComponent = () => {
	const {
		blockClass,
		showFieldsProps: { showSku },
		mzProductName,
	} = useProductSummaryName();

	if (!showSku) return null;

	return (
		<span
			className={`
      productBrand
      productBrand--${blockClass}
      vtex-product-summary-2-x-productBrand 
      vtex-product-summary-2-x-productBrand--${blockClass}
      skuName
      skuName--${blockClass}
      vtex-product-summary-2-x-skuName 
      vtex-product-summary-2-x-skuName--${blockClass} 
      t-small`}
		>
			{mzProductName ? mzProductName : 'Calça selva noturna roupa de inverno'}
		</span>
	);
};

export default ProductNameComponent;
